import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer } from '../../styled/layout.styled';
import { H3, H6 } from '../../styled/typograpghy.styled';
import crownIcon from './assets/Hero_Crown@2x.png';
import chipIcon from './assets/Hero_Chip@2x.png';

const StyledFlexContainer = styled(FlexContainer)`
  width: 100%;
  position: relative;
  border-radius: 5px 5px 0 0;
  background-image: linear-gradient(to top, #1a0949, #22096c);
`;

const StyledSpan = styled.span`
  color: ${({ theme }) => theme.color.white};
`;

const StyledProgressBarContainer = styled.div`
  width: 100%;
  height: 16px;
  position: relative;
  margin: 8px 0 0 0;
  border-radius: 10px;
  box-shadow: inset 0 2px 9px 0 rgba(0, 0, 0, 0.7);
  background-color: #22096c;
`;
const StyledProgressLoader = styled.div`
  width: ${({ loaderWidth }) => loaderWidth}%;
  height: 16px;
  position: absolute;
  top: 0;
  border-radius: 10px;
  background-color: #ff2976;
`;

const StyledImageContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
  img {
    width: ${({ width }) => width};
  }
`;

const CommissionRateCard = ({
  tierName, commissionRate, referrals, requiredReferrals, requiredWagered, wagered,
}) => (
  <StyledFlexContainer flexDirection="column" padding="24px 29px 24px 29px">
    <StyledImageContainer width="51px" top="-33px" left="0">
      <img src={crownIcon} alt="crown-icon" />
    </StyledImageContainer>
    <StyledImageContainer width="67px" bottom="-52px" right="0">
      <img src={chipIcon} alt="chip-icon" />
    </StyledImageContainer>
    <FlexContainer flexWrap width="100%" justifyContent="space-between">
      <FlexContainer flexDirection="column" alignItems="center">
        <StyledSpan className="xsmall">Level</StyledSpan>
        <H3 margin="4px 0 0 0">{tierName}</H3>
      </FlexContainer>
      <FlexContainer flexDirection="column" alignItems="center">
        <StyledSpan className="xsmall">Commission Rate</StyledSpan>
        <H3 margin="4px 0 0 0">{commissionRate * 100}%</H3>
      </FlexContainer>
      <FlexContainer flexDirection="column" alignItems="center">
        <StyledSpan className="xsmall">Referrals</StyledSpan>
        <H3 margin="4px 0 0 0">{requiredReferrals ? `${referrals}/${requiredReferrals}` : referrals}</H3>
      </FlexContainer>
    </FlexContainer>
    <FlexContainer flexDirection="column">
      <FlexContainer margin="28px 0 0 0" justifyContent="space-between" alignItems="center">
        <StyledSpan className="xsmall">Wagered</StyledSpan>
        <H6 margin="0" color="#fff">
          {wagered === 0 ? wagered : wagered.toFixed(2)} / {requiredWagered.toFixed(2)}
        </H6>
      </FlexContainer>
      <StyledProgressBarContainer>
        <StyledProgressLoader loaderWidth={wagered >= requiredWagered ? 100 : (wagered / requiredWagered) * 100} />
      </StyledProgressBarContainer>
    </FlexContainer>
  </StyledFlexContainer>
);

CommissionRateCard.propTypes = {
  tierName: PropTypes.string.isRequired,
  commissionRate: PropTypes.number.isRequired,
  referrals: PropTypes.number.isRequired,
  requiredReferrals: PropTypes.number.isRequired,
  requiredWagered: PropTypes.number.isRequired,
  wagered: PropTypes.number.isRequired,
};

export default CommissionRateCard;
